<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.pages.tagName`),
    }"
    class="cms-page-card result-card"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:sticky-note"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="url"
        class="title"
        @click="handleResultClick"
        >{{ searchResult.name }}</a
      >
      <div
        v-if="searchResult.snippet"
        class="snippet"
      >
        {{ searchResult.snippet }}
      </div>
      <PublishedUpdatedDate :search-result="searchResult" />
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import PublishedUpdatedDate from './PublishedUpdatedDate.vue';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['result-clicked']);

const url = computed(() => {
  return `${props.searchResult.link}/page/${props.searchResult.slug}`;
});

function handleResultClick() {
  emit('result-clicked', {
    position: props.resultPosition,
    url: url.value,
  });
}
</script>

<style scoped>
.cms-page-card {
  --background-color: #f3f6fc;
  --text-color: #1850c1;

  .title {
    line-height: 120%;
  }
}
</style>
